import React from 'react';
import { useEffect } from 'react';
import LcIconLink from '../../Generic/LcIconLink';
import './SideModal.css';

interface Props {
    visible: boolean
    header: string | React.ReactNode
    onClose: Function
    width?: string
    fixedHeader?: boolean,
    backgroundColor?: string,
    drilldown?: boolean
    height?: string
}

const SideModal: React.FC<Props> = (props) => {

    useEffect(() => {
        if (props.visible) {
            let firstInput = document.querySelector('.side-modal.visible .body input') as HTMLInputElement;
            firstInput && firstInput.focus();
        }
    }, [props.visible])

    const getStyle = () => {
        const styleFixed = {
            position: "sticky",
            top: '0',
            // backgroundColor: window.screen.width > 600 ? "#E2E6F3" : '',
            backgroundColor:( window.screen.width > 600) ? "#F1F5FB" : '',
            // borderBottom: "1px solid lightgrey",
            zIndex: "100",
        } as React.CSSProperties;

        return (props.fixedHeader && props.fixedHeader === true) ? styleFixed : undefined;
    }

    return (
        <div className={`side-modal ${props.drilldown && 'drilldown'} ${props.visible && 'visible'} scrollable-v `}
            style={{
                width: props.visible ? (props.width || '35rem') : '',
                backgroundColor: props.backgroundColor,
                bottom: '0'
            }}>
            <div className={window.screen.width > 600 ? "header" : 'headerMobile'} style={getStyle()}>
                {
                    (typeof props.header === 'string')
                        ? <span>{props.header}</span>
                        : props.header
                }
                <LcIconLink tooltip="Fechar" icon={'link ppi ppi-x'} size={'big'} onClick={() => props.onClose(false)} />
                {/* <div className="lciconlink">
                    <i className="link ppi ppi-x" onClick={() => props.onClose(false)} />
                </div> */}

            </div>

            <div className={(window.screen.width > 600) ? "body" : 'bodyMobile' } style={{ height: (props.height ? props.height : 'calc(100% - 100px)') }}>
                {props.children}
            </div>
        </div>
    );
}

export default SideModal;